import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=77c2bf5a&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=ts"
export * from "./editDialog.vue?vue&type=script&lang=ts"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=77c2bf5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2bf5a",
  null
  
)

export default component.exports